import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "show",
  "use": "show-usage",
  "viewBox": "0 0 26 16",
  "content": "<symbol viewBox=\"0 0 26 16\" id=\"show\">\n<defs>\n    <style>\n      #show .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path class=\"cls-1\" d=\"M1543,66c6.76,0,13,4.385,13,8s-6.24,8-13,8-13-4.385-13-8S1536.24,66,1543,66Zm0,1.454c5.91,0,11.47,3.734,11.47,6.545s-5.56,6.546-11.47,6.546-11.47-3.734-11.47-6.546S1537.09,67.455,1543,67.455Zm0,2.9A3.648,3.648,0,1,1,1539.16,74,3.746,3.746,0,0,1,1543,70.357Zm0,1.107A2.539,2.539,0,1,1,1540.34,74,2.6,2.6,0,0,1,1543,71.464Z\" transform=\"translate(-1530 -66)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/show.svg
// module id = vsUp
// module chunks = 264